import { render } from "./CurvedTeamName.vue?vue&type=template&id=fa223c68"
import script from "./CurvedTeamName.vue?vue&type=script&lang=js"
export * from "./CurvedTeamName.vue?vue&type=script&lang=js"

import exportComponent from "/srv/users/dyo-frontend/apps/dyo-frontend/public_html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__